/* eslint no-unused-vars: "off" */
import _ from "../../quotation/experiments/jquery.min";

const AlbumController = ($scope, $http, $filter) => {
  $scope.data = {
    image_id: undefined,
    albums: undefined,
    album: undefined,
    show_albums: false,
    saved_in: false,
  };

  $scope.fields = {
    albumName: '',
    imageDescription: '',
  };

  $scope.init = function(id, source_page) {
    $scope.data.image_id = id;
    Login.pop({
      source_page: source_page,
      source_action: 'photo_add_photo_to_album',
      title:
        __('¿A que es genial esta foto?') +
        '<small>' +
        __(
          'Necesitamos que entres a tu cuenta o estés registrado para poder guardarla'
        ) +
        '</small>',
      onsuccess: function() {
        $http({
          url: Hab.config.api_root + '/me/albums',
          method: 'GET',
          withCredentials: true,
        }).success(function(data) {
          $scope.data.albums = data;
          $scope.checkIfAlreadySaved();
          $scope.openPopup();
        });
      },
    });
  };

  $scope.checkIfAlreadySaved = function() {
    $($scope.data.albums).each(function() {
      if($.inArray($scope.data.image_id.toString(), this.rel_images) >= 0) {
        $scope.data.saved_in = this;
        $filter('filter')($scope.data.albums, { id: this.id })[0][
          'disabled'
        ] = true;
      }
    });
  };

  $scope.saveImage = function() {
    $http({
      url: Hab.config.api_root + '/me/albums/' + $scope.data.album.id,
      method: 'PUT',
      withCredentials: true,
      data: {
        image_id: $scope.data.image_id,
        description: $scope.fields.imageDescription,
      },
    })
      .success(function() {
        $scope.closePopup();
        setTimeout(function() {
          $scope.data.album_not_exists = false;
          bootbox.alert(
            __(
              'Has guardado la foto en <a href="{album_url}">el álbum <strong>{album}</strong></a>',
              {
                album: $scope.data.album.name,
                album_url: nano(Hab.config.user_albums_show_url_template, {
                  id: $scope.data.album.id,
                }),
              }
            )
          );
        }, 200);
      })
      .error(function() {
        $scope.data.album_not_exists = true;
      });
  };

  $scope.addAlbum = function() {
    $http({
      url: Hab.config.api_root + '/me/albums',
      method: 'PUT',
      withCredentials: true,
      data: { name: $scope.fields.albumName },
    }).success(function(data) {
      $scope.data.album = data;
      $scope.data.albums.push(data);
      $scope.data.show_albums = false;
      $scope.fields.albumName = '';
    });
  };

  $scope.openAlbums = function() {
    $scope.data.show_albums = true;
  };

  $scope.selectAlbum = function(album, $event) {
    // don't fire openAlbums as it is the parent and also has a click event
    $event.stopImmediatePropagation();
    // also don't follow link
    $event.preventDefault();

    if (album.disabled) {
      return false;
    }

    $scope.data.album = album;
    $scope.data.show_albums = false;
  };

  $scope.openPopup = function() {
    $('#album-selector-popup').modal('show');
  };

  $scope.closePopup = function() {
    $('#album-selector-popup').modal('hide');
  };
};

AlbumController.$inject = ['$scope', '$http', '$filter'];

export default AlbumController;
